import "./App.css";
import { Link } from "react-router-dom";
function Download() {
  const handleAndroidDownload = () => {
    // URL to the app file
    const appFileUrl =
      "https://play.google.com/store/apps/details?id=com.raya.media";
    const link = document.createElement("a");
    link.href = appFileUrl;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleIosDownload = () => {
    // URL to the app file
    const appFileUrl = "https://apps.apple.com/";
    const link = document.createElement("a");
    link.href = appFileUrl;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <h1 className="about-head col-12 heading-font" id="download">
            Download App
          </h1>

          <div className="col-12 col-lg-5 d-flex flex-row justify-content-center">
            <div className="image-container min-container d-flex flex-column w-100 h-100">
              <div className="mt-2 w-100 h-100 d-flex flex-row justify-content-center">
                <img
                  src="/downloadSwara.png"
                  className="service-height"
                  style={{ borderRadius: 10 }}
                />
              </div>

              <div className="d-flex flex-row justify-content-center w-100 h-100">
                <img
                  src={"/android download.png"}
                  className="android-download"
                  onClick={handleAndroidDownload}
                  alt=""
                />

                <img
                  src={"/download.jpeg"}
                  className="ios-download"
                  onClick={handleIosDownload}
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-7">
            <div className="text-container min-container">
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: 25,
                }}
                className="text-size text-font"
              >
                {/* Get the "Eat Protein" App for Android and iOS */}
              </span>
              <br />

              <p
                className="para-text-size text-font para-text-size"
                style={{
                  marginLeft: 0,
                }}
              >
                Discover a world of audio entertainment with Raya Creations!
                From live radio stations to inspiring podcasts, your favorite
                shows are just a tap away. Whether you’re tuning in to the
                latest hits or exploring captivating stories, our app is your
                gateway to endless audio experiences.
              </p>

              <h4
                style={{
                  fontWeight: "bold",
                  fontSize: 24,
                }}
                className="text-size heading-font"
              >
                Available on Android and iOS
              </h4>

              <h4 style={{}} className="text-size text-font para-text-size">
                Download the Raya Creations app now and elevate your listening
                journey:
              </h4>

              <h4
                style={{
                  fontWeight: "bold",
                  fontSize: 24,
                }}
                className="text-size heading-font"
              >
                Why Choose Raya Creations?
              </h4>
              <p
                className="para-text-size text-font para-text-size"
                style={{ marginLeft: 0 }}
              >
                Stream live radio from across the globe.
                <br />
                • Explore a wide variety of podcasts on topics you love.
                <br />
                • Create and share your own podcasts effortlessly.
                <br />
                • Enjoy a seamless, ad-free listening experience.
                <br />
              </p>
              <p
                className="para-text-size text-font para-text-size"
                style={{
                  marginLeft: 0,
                }}
              >
                Your audio adventure starts here!
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Download;
